export type CustomSVGType = {
    width?: string | number;
    height?: string | number;
};

export const BrownSideSVG: React.FC<CustomSVGType> = ({ height, width }) => (
    <svg
        width={width}
        height={height}
        viewBox={`0 0 355 720`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_567_29066)">
            <path
                d="M0 20C0 8.95432 8.9543 0 20 0H355V720H20C8.9543 720 0 711.046 0 700V20Z"
                fill="#69635B"
            />
            <g style={{ mixBlendMode: 'soft-light' }}>
                <path
                    d="M649.5 224.752V646.675C649.5 659.912 647.722 672.738 644.302 684.883C636.984 711.424 622.21 734.894 602.376 752.907C593.143 761.299 582.815 768.463 571.598 774.194C564.964 777.673 557.988 780.607 550.738 782.995C536.58 787.635 521.465 790.159 505.734 790.159C472.494 790.159 441.922 778.97 417.573 760.002L87.5 430.733L142.558 375.809L369.081 601.781L450.676 683.177L467.57 700.03C478.513 710.946 493.081 717.906 508.538 717.974C508.675 717.974 508.743 717.974 508.88 717.974C525.158 717.974 540.068 712.038 551.627 702.281C551.695 702.213 551.832 702.145 551.901 702.077C564.827 690.955 571.598 674.308 571.598 657.251V244.948C571.598 222.501 560.518 202.646 543.488 190.501C532.408 182.587 518.798 177.879 504.024 177.879C486.857 177.879 471.195 184.224 459.294 194.732C457.242 196.506 455.327 198.416 453.48 200.463L383.239 270.26L347.537 305.944L292.479 251.02L414.017 129.71L416.753 127.049C441.443 102.965 475.162 88.1592 512.437 88.1592C528.441 88.1592 543.83 90.8883 558.056 95.9372C562.707 97.5064 567.221 99.4168 571.598 101.464C584.935 107.877 597.11 116.337 607.642 126.503C627.203 145.334 641.156 169.897 646.696 197.393C648.542 206.262 649.5 215.405 649.5 224.752Z"
                    fill="#6A6967"
                />
            </g>
            <g style={{ mixBlendMode: 'soft-light' }}>
                <path
                    d="M-286.5 540.566V118.643C-286.5 105.407 -284.729 92.5799 -281.324 80.4353C-274.038 53.8945 -259.328 30.424 -239.579 12.4118C-230.386 4.01971 -220.103 -3.14425 -208.935 -8.87542C-202.329 -12.3551 -195.383 -15.2889 -188.164 -17.6769C-174.068 -22.3164 -159.018 -24.8408 -143.355 -24.8408C-110.259 -24.8408 -79.8181 -13.6514 -55.5747 5.31605L258.5 319.985L203.68 374.908L-7.29221 163.537L-88.5349 82.141L-105.355 65.2886C-116.251 54.3721 -130.757 47.4129 -146.147 47.3446C-146.283 47.3446 -146.351 47.3446 -146.488 47.3446C-162.695 47.3446 -177.541 53.2805 -189.05 63.0371C-189.118 63.1053 -189.254 63.1736 -189.322 63.2418C-202.193 74.363 -208.935 91.0107 -208.935 108.068V520.371C-208.935 542.818 -197.903 562.672 -180.946 574.817C-169.914 582.731 -156.362 587.439 -141.652 587.439C-124.559 587.439 -108.965 581.094 -97.1154 570.587C-95.0724 568.813 -93.1656 566.902 -91.3269 564.856L-21.3888 495.058L14.1591 459.375L68.9792 514.298L-52.0335 635.608L-54.7575 638.269C-79.3414 662.354 -112.914 677.159 -150.029 677.159C-165.964 677.159 -181.286 674.43 -195.451 669.381C-200.082 667.812 -204.576 665.901 -208.935 663.855C-222.214 657.441 -234.336 648.981 -244.823 638.815C-264.3 619.984 -278.192 595.422 -283.708 567.926C-285.547 559.056 -286.5 549.914 -286.5 540.566Z"
                    fill="#6A6967"
                />
            </g>
        </g>
        <defs>
            <clipPath id="clip0_567_29066">
                <path
                    d="M0 20C0 8.95432 8.9543 0 20 0H355V720H20C8.9543 720 0 711.046 0 700V20Z"
                    fill="white"
                />
            </clipPath>
        </defs>
    </svg>
);

BrownSideSVG.defaultProps = {
    width: '355',
    height: '720',
};
